import { render, staticRenderFns } from "./MobileHomeAbout.vue?vue&type=template&id=5edd3e38&lang=pug&"
import script from "./MobileHomeAbout.vue?vue&type=script&lang=js&"
export * from "./MobileHomeAbout.vue?vue&type=script&lang=js&"
import style0 from "./MobileHomeAbout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports